import VIDEO_TYPE from "enums/VIDEO_TYPE";
import { useContext, useEffect, useRef } from "react";
import TimelinePlayerContext from "../context/TimelinePlayerContext";
import getDetailsAtAbsoluteTime from "../utils/getDetailsAtAbsoluteTime";

const BASIC_PLAYER_TYPES: VIDEO_TYPE[] = [
  VIDEO_TYPE.VIDEO,
  VIDEO_TYPE.CLIP,
  VIDEO_TYPE.INSIGHT,
];

export default function useSeekToAbsoluteTimeHandler() {
  const {
    player,
    setAbsoluteTime,
    seekToAbsolutePosition,
    setSeekToAbsolutePosition,
    setPlayer,
    setSeekToAfterPlayerInit,
    timelinePositions,
    timelineItemIndex,
  } = useContext(TimelinePlayerContext);

  const playerRef = useRef(player);
  playerRef.current = player;

  useEffect(() => {
    if (seekToAbsolutePosition == undefined) return;
    const {
      videoId: nextVideoId,
      type: nextType,
      relativeTime,
      timelineItemIndex: nextTimelineItemIndex,
    } = getDetailsAtAbsoluteTime(seekToAbsolutePosition, timelinePositions);

    // The next item renders as BasicPlayer when it has a videoId (playlist
    // case) or is a real video type (share case where signedSourceUrl carries
    // the source). Anything else (IMAGE, PDF, plain transitions) renders as
    // TransitionPlayer and must not stamp a seekToAfterPlayerInit, otherwise
    // the value lingers and re-fires once a later BasicPlayer mounts.
    const nextRendersAsBasicPlayer =
      nextVideoId != undefined ||
      BASIC_PLAYER_TYPES.includes(nextType as VIDEO_TYPE);

    const currentPlayer = playerRef.current;

    if (
      !nextRendersAsBasicPlayer &&
      timelinePositions.size > 0 &&
      timelineItemIndex !== nextTimelineItemIndex
    ) {
      setPlayer(undefined);
    } else if (
      timelineItemIndex !== nextTimelineItemIndex &&
      nextRendersAsBasicPlayer
    ) {
      setPlayer(undefined);
      setSeekToAfterPlayerInit(seekToAbsolutePosition);
    } else if (currentPlayer && relativeTime != undefined) {
      currentPlayer.seekTo(relativeTime, "seconds");
    }
    setAbsoluteTime(seekToAbsolutePosition);
    setSeekToAbsolutePosition(undefined);
  }, [seekToAbsolutePosition]);
}
